import { Calendar } from '@fullcalendar/core';
import koLocale from '@fullcalendar/core/locales/ko';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import googleCalendarPlugin from '@fullcalendar/google-calendar';

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '@fullcalendar/list/main.css';

const calendarEl = document.getElementById( 'calendar' );
const calendar = new Calendar( calendarEl, {
	timeZome: 'Asia/Seoul',
	plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, googleCalendarPlugin ],
	themeSystem: 'bootstrap',
	header: {
		left: 'prev,next',
		center: 'title',
		//right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
		right: 'today'
	},
	locale: koLocale,
	defaultView: 'dayGridMonth',
	googleCalendarApiKey: 'AIzaSyDYKmNdsTia4YU9tVmyCNbMI2ujyoOKWbo',
	eventSources: [
		{
			googleCalendarId: 'nehemiah4nextgeneration@gmail.com'
		},
		{
			googleCalendarId: 'ko.south_korea#holiday@group.v.calendar.google.com',
			className: 'event-holiday'
		}
	],
	eventClick: function(info) {
		info.jsEvent.preventDefault(); // don't let the browser navigate

		if (info.event.url) {
			window.open(info.event.url);
		}
	}
} );

calendar.render();
